import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth';
import 'firebase/functions'

// import 'firebase/storage'

let database = null


const init = function () {
    database = firebase.database() 
}

const getRef = function (path) {
    return firebase.database()
}

const currentUser = function () {
    console.log('looking for current user ', firebase.auth().currentU)
    return firebase.auth().currentUser;
} 

const signOut = function() {
    return firebase.auth().signOut()
}

const callFunc = function (f) {
    let fname = f.toString()
    return firebase.functions().httpsCallable(fname)
}

const anonAuth = function (){
    return firebase.auth().signInAnonymously().catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        return error
        // ...
      });
}

// const fbAuth = function () {
//     return firebase.auth()
// }

// const coverRef = function () {
//     return firebase.storage().ref().child('covers/')
// }

// const db = function () {
//     return database
// }


// const firestore = firebase.firestore();
// const settings = {/* your settings... */ timestampsInSnapshots: true };
// firestore.settings(settings);


export default { init, getRef, anonAuth, currentUser, signOut, callFunc }